/**
 * Tour step definitions for the AI Trader page.
 * @returns {Array} react-joyride steps
 */
export function getAiTraderTourSteps() {
  return [
    {
      target: '[data-tour="ai-info-bar"]',
      title: 'Challenge Dashboard',
      content: 'Track the AI\'s balance, equity, and margin usage in real time. This is where you see how the $10,000 challenge is going.',
      placement: 'bottom',
      disableBeacon: true
    },
    {
      target: '[data-tour="ai-chart-section"]',
      title: 'Equity Curve',
      content: 'The AI\'s performance over time. Watch the equity line grow (or shrink) as it makes trades. Every move is recorded.',
      placement: 'bottom',
      disableBeacon: true
    },
    {
      target: '[data-tour="ai-positions-table"]',
      title: 'Positions & Trade History',
      content: 'See every open position and the full trade history. Click any row to see the AI\'s reasoning for that trade.',
      placement: 'left',
      disableBeacon: true
    },
    {
      target: '[data-tour="ai-log-panel"]',
      title: 'AI Decision Log',
      content: 'The AI\'s brain in real time. Every scan, analysis, and trade decision appears here as it happens. This is the raw feed of what the AI is thinking.',
      placement: 'left',
      disableBeacon: true
    },
    {
      target: '[data-tour="header-help-button"]',
      title: 'Restart This Tour',
      content: 'You can replay this tour anytime by clicking the help button. Enjoy the show!',
      placement: 'bottom',
      disableBeacon: true
    }
  ];
}
